import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-audioplayer',
  templateUrl: './audioplayer.component.html',
  styleUrls: ['./audioplayer.component.scss']
})
export class Audioplayer {
  isPlay: boolean;
  audio: any;

  @Input() formItem: any;
  @Input() formId: any;
  @ViewChild('audio') audioPlayerRef: ElementRef;


  getAudioUrl() {
    return `${environment.url.api}api/item/audio/${this.formId}/${this.formItem.item.audioFileName}`;
  }

  playOrPause() {
    this.isPlay = !this.isPlay;
    if (this.isPlay) {
      this.audioPlayerRef.nativeElement.play();
    }
    else {
      this.audioPlayerRef.nativeElement.pause();
    }
  }
}
